export const removeLocalStorage = (key: string) => {
  if (typeof window === 'undefined') {
    console.warn(
      `Tried removing localStorage key “${key}” even though environment is not a client`
    );
    return;
  }

  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.warn(`Error removing localStorage key “${key}”:`, error);
  }
};

export default removeLocalStorage;
